import { getRequest, postRequest, patchRequest } from "../utils/axios";

const projectQuery = (projectHash) => `?project=${projectHash}`;

const buildQuery = (projectHash, filters = {}) => {
  const params = new URLSearchParams({ project: projectHash });
  if (filters.agent_type) params.set("agent_type", filters.agent_type);
  return `?${params.toString()}`;
};

export const changeRequestsService = {
  list: (projectHash, filters, onSuccess, onError) =>
    getRequest(`/api/v1/change-requests/${buildQuery(projectHash, filters || {})}`, onSuccess, onError),
  get: (projectHash, hash, onSuccess, onError) =>
    getRequest(`/api/v1/change-requests/${hash}/${projectQuery(projectHash)}`, onSuccess, onError),
  create: (projectHash, description, source, onSuccess, onError, options = {}) =>
    postRequest(
      `/api/v1/change-requests/${projectQuery(projectHash)}`,
      {
        description,
        source,
        ...(options.agent_type ? { agent_type: options.agent_type } : {}),
        ...(options.model_override !== undefined ? { model_override: options.model_override } : {}),
        ...(options.suggestions?.length ? { suggestions: options.suggestions } : {}),
      },
      onSuccess,
      onError,
    ),
  cancel: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/change-requests/${hash}/cancel/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  stop: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/change-requests/${hash}/stop/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  approve: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/change-requests/${hash}/approve/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  reject: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/change-requests/${hash}/reject/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  retry: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/change-requests/${hash}/retry/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  update: (projectHash, hash, data, onSuccess, onError) =>
    patchRequest(
      `/api/v1/change-requests/${hash}/${projectQuery(projectHash)}`,
      data,
      onSuccess,
      onError,
    ),
};
